// ---------------- password rules ----------------
const passwordChecker = {
  isValid(pwd) {
    return (
      pwd.length > 6 &&
      /[!@#$%^&*(),.?":{}|<>]/.test(pwd) &&
      /[A-Z]/.test(pwd)
    );
  },
  getErrorMessage() {
    return "Password must be more than 6 characters, include at least one capital letter and one special character.";
  },
};

// --------------- validator class ----------------
class TemplatePasswordJS {
  constructor(form, input) {
    this.form = form;
    this.passwordInput = input;
    this.mount();
  }

  mount() {
    if (!this.form || !this.passwordInput) return;

    // build error node
    this.errorEl = document.createElement("div");
    this.errorEl.className = "text-danger mt-1";
    this.errorEl.hidden = true;
    this.passwordInput.insertAdjacentElement("afterend", this.errorEl);

    // handle submit
    this.form.addEventListener("submit", (e) => {
      const pwd = this.passwordInput.value;

      if (passwordChecker.isValid(pwd)) {
        this.errorEl.hidden = true;
        this.passwordInput.classList.remove("is-invalid");
        return;                // ⬅ let Shopify handle submission
      }

      // block submission – stop everyone
      e.preventDefault();
      e.stopImmediatePropagation(); // blocks any other submit listeners
      this.errorEl.textContent = passwordChecker.getErrorMessage();
      this.errorEl.hidden = false;
      this.passwordInput.classList.add("is-invalid");
    });
  }
}

// ------------- wait until the form exists -------
document.addEventListener("DOMContentLoaded", () => {
  new TemplatePasswordJS(
    document.querySelector("#create_customer"),
    document.querySelector("#registerCustomerPassword")
  );
});
